
import EoIcon from '../../EoIcon/EoIcon.vue'

export default {
  name: 'EoNavLink',
  components: { EoIcon },
  props: {
    /**
     * Textual label of the item
     */
    label: {
      type: String,
      default: '',
      required: true,
    },
    /**
     * Icon to show before label
     */
    iconBefore: {
      type: String,
      default: null,
    },
    /**
     * Icon to show after the label
     */
    iconAfter: {
      type: String,
      default: null,
    },
    /**
     * Style: text size and accompanied styling (md) (lg) (xl)
     */
    size: {
      type: String,
      default: "md",
    },
    /**
     * Style: default color of the text and icons
     */
    textColor: {
      type: String,
      default: null,
    },
  },
}
